module.exports = __webpack_public_path__ + "static/8-map-1fb68a8a79a38eddfdcfbb44a77a06fa.jpg";